<ng-container *ngIf="(account$ | async) as account">

  <div class="p-d-flex p-jc-end mb-3">
    <button
      pButton
      pRipple
      type="button"
      label="Add package"
      icon="pi pi-plus"
      class="p-button-rounded"
      (click)="onAddPackage($event)"
    ></button>
  </div>

  <p-table
    #packagesTable
    [value]="packagesAsList(account.data?.packages)"
    [globalFilterFields]="['name', 'slug', 'tagline']"
    styleClass="mt-3 p-datatable-striped"
    dataKey="_meta.id"
    responsiveLayout="scroll"
  >

    <ng-template pTemplate="caption">
      <div class="p-d-flex">
        <span class="p-input-icon-left p-ml-auto">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="packagesTable.filterGlobal($any($event).target.value, 'contains')"
            placeholder="Search packages"
          />
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Slug</th>
        <th>Featured</th>
        <th>Price</th>
        <th style="width: 12rem"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-package>
      <tr [pSelectableRow]="package" [class.is-deleted]="package._meta.deleted">
        <td>
          <strong>{{ package.name || '(unnamed)' }}</strong>
          <div *ngIf="package.tagline" class="text-sm muted">{{ package.tagline }}</div>
        </td>
        <td>
          <code *ngIf="package.slug">{{ package.slug }}</code>
          <span *ngIf="!package.slug" class="muted">—</span>
        </td>
        <td>
          <i
            *ngIf="package.isFeatured"
            class="pi pi-star-fill"
            aria-label="Featured package"
            title="Featured on the homepage"
          ></i>
        </td>
        <td>
          <span *ngIf="package.price != null">{{ package.price | currency:'AUD' }}</span>
          <span *ngIf="package.price == null" class="muted">POA</span>
        </td>
        <td class="package-actions">
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-pencil"
            (click)="onEditPackage($event, package)"
            class="p-button-rounded p-button-text"
            title="Edit"
          ></button>
          <button
            *ngIf="!package._meta.deleted"
            pButton
            pRipple
            type="button"
            icon="pi pi-trash"
            (click)="onDeletePackage($event, package)"
            class="p-button-rounded p-button-danger p-button-text"
            title="Remove"
          ></button>
          <button
            *ngIf="package._meta.deleted"
            pButton
            pRipple
            type="button"
            icon="pi pi-refresh"
            (click)="onRestorePackage($event, package)"
            class="p-button-rounded p-button-success p-button-text"
            title="Restore"
          ></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="p-text-center muted p-py-5">
          No packages yet. Use "Add package" to create the first one.
        </td>
      </tr>
    </ng-template>

  </p-table>

</ng-container>
